import { apiV2Client } from '@/services/client/ApiClient.js';

export default {
  getMe() {
    return apiV2Client.get(`/me/`).then((response) => {
      return response.data.data;
    });
  }
};
